import { FC, SVGProps } from 'react';

export const CalendarIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
		<g clipPath="url(#clip0_4248_21698)">
			<path
				d="M9.3 3.8064V5.64511H14.7V3.8064H16.5V5.64511H20.1C20.597 5.64511 21 6.05672 21 6.56446V21.2741C21 21.7819 20.597 22.1935 20.1 22.1935H3.9C3.40295 22.1935 3 21.7819 3 21.2741V6.56446C3 6.05672 3.40295 5.64511 3.9 5.64511H7.5V3.8064H9.3ZM19.2 12.9999H4.8V20.3548H19.2V12.9999ZM7.5 7.48382H4.8V11.1612H19.2V7.48382H16.5V9.32253H14.7V7.48382H9.3V9.32253H7.5V7.48382Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_4248_21698">
				<rect width="18" height="19" fill="currentColor" transform="translate(3 3.5)" />
			</clipPath>
		</defs>
	</svg>
);
